import React, { createElement, useEffect, useState } from 'react';
import { Message } from '@alifd/next';
import { fetchApplication } from '../../../api/report';
import './index.scss';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const appid = urlParams.get('applicationId');
const Text = (props, ref) => {
    const { text, styles, style, dynamic, dynamicType, inline } = props;
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const [styleSet, setStyleSet] = useState({});
    const [itext, setItext] = useState('');
    useEffect(() => {
        setStyleSet({
            ...styles,
            width: styles?.widthHeightVisible ? styles.width + 'px' : 'unset',
            height: styles?.widthHeightVisible ? styles.height + 'px' : 'unset',
            lineHeight: styles?.widthHeightVisible ? styles.lineHeight + 'px' : 'unset',
            display: inline ? 'inline-block' : 'block',
            verticalAlign: 'middle'
        });
    }, [styles, inline]);
    useEffect(() => {
        setError(false);
        if (dynamic) {
            if (dynamicType === 'appName') {
                try {
                    if (appid) {
                        fetchApplication(appid).then((res) => {
                            setItext(res.data.applicationName);
                        });
                    }
                    else {
                        Message.error('未获取到应用ID!');
                    }
                }
                catch (error) {
                    console.log(error);
                    setError(true);
                    setErrmsg('获取应用名称异常失败!请检查新版本组件是否还支持该字段');
                }
            }
        }
        else {
            setItext(text);
        }
    }, [text, dynamic, dynamicType]);
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement("div", { ref: ref, className: "base-tex base_bg", style: { ...style, ...styleSet } }, itext))));
};
export default React.forwardRef(Text);
